import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Injectable } from '@angular/core';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import { environment } from 'src/environments/environment';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  private functions = getFunctions(getApp(), 'us-central1');

  constructor(private fns: AngularFireFunctions) {
    if (!environment.production) {
     // this.fns.useEmulator('localhost', 5001);
    }
  }

  sendPushNotification(userIds: string[], title: string, body: string, link: string): Observable<any> {
    const callable = httpsCallable(this.functions, 'addnummbers');

    const payload = {
      firstNumber: 2,
      secondNumber: 3,     
    };

    return from(callable(payload)).pipe(
      map(result => result.data)
    );
  }
}
